
import React from 'react';
import { Check } from 'lucide-react';

const CtoServiceAssessment = () => {
  const steps = [
    {
      title: "IT-Check & Ziel-Workshop (1 Tag)",
      description: "Wir durchleuchten deine aktuelle IT, Kosten­treiber und Unternehmens­ziele."
    },
    {
      title: "Fahrplan & Budget (2 Wochen)",
      description: "Liste der Projekte, Zeitplan, Kostenrahmen – alles schwarz auf weiß."
    },
    {
      title: "Monatliche Begleitung",
      description: "Kosten-Updates, Anbieter­steuerung, Risiko-Check."
    },
    {
      title: "Quartals­bericht",
      description: "Fortschritt, Ausgaben, nächste Schritte – kompakt fürs Management."
    },
    {
      title: "Jährlicher Rundum-Check",
      description: "Markt­trends, neue Chancen, Budget­anpassung."
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Unser Fahrplan mit dir</h2>
        </div>
        
        <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-md overflow-hidden">
          <div className="p-8">
            {steps.map((step, index) => (
              <div key={index} className="flex items-start mb-6 last:mb-0">
                <div className="flex-shrink-0 mt-1">
                  <Check className="h-6 w-6 text-green-500" />
                </div>
                <div className="ml-3">
                  <h3 className="text-lg font-medium text-gray-800 mb-1">{step.title}</h3>
                  <p className="text-gray-600">{step.description}</p>
                </div>
              </div>
            ))}
            
            <div className="mt-8 p-5 bg-blue-50 rounded-lg">
              <p className="text-base italic text-blue-800">
                "18 % weniger IT-Kosten und die Projekte laufen schneller. Für uns ein echter Gewinn." <br/>
                <span className="font-medium mt-2 block">— Laura Ritter, MedTech-Start GmbH</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtoServiceAssessment;
